<template>
  <div class="py-5 mt-4">
    <div>
      <h2 class="titlePage font-weight-bold text-capitalize mb-1 h2">
        {{ $t('settings.twoWay.results.title') }}
      </h2>
    </div>

    <CAlert v-if="hasNoTwoWay" color="purple-200" class="d-flex align-items-center w-100 mt-3">
      <CIcon class="text-primary" name="notificationAlert" :height="32" viewBox="0 0 32 32" />
      <CCol sm="8" class="my-2">
        <h2 class="font-lg mb-1 text-primary">{{ $t('settings.twoWay.results.no-twoWay.title') }}</h2>
        <p class="font-md m-0 text-primary">{{ $t('settings.twoWay.results.no-twoWay.description') }}</p>
      </CCol>
      <CCol class="text-right">
        <CButton @click="redirectToConfiguration" color="primary">{{ $t('settings.twoWay.results.no-twoWay.button') }}</CButton>
      </CCol>
    </CAlert>
    <CCard class="mt-3">
      <CCardHeader class="font-weight-bold">{{ $t('settings.twoWay.results.card.title') }}</CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <label class="label-custom">{{ $t('settings.twoWay.results.filters.origin-number') }}</label>
            <CInput v-model="originNumber" class="custom-form-control" :disabled="loading" @keyup="originNumberInputCheck" />
          </CCol>
          <CCol>
            <label class="label-custom">{{ $t('settings.twoWay.results.filters.destination-number') }}</label>
            <v-select
              v-model="destinationNumberSelected"
              class="no-close border-gray-300 rounded select"
              item-text="label"
              item-value="value"
              :disabled="loading"
              :searchable="true"
              :options="destinationNumberOptions"
            />
          </CCol>
          <!-- <CCol>
            <label class="label-custom">{{ $t('settings.twoWay.results.filters.date-of-receipt') }}</label>
            <v-date-picker v-model="dateOfReceipt" color="purple" timezone="UTC" :locale="lang" :max-date="new Date()" is-required class="select">
              <template v-slot="{ inputEvents, inputValue }">
                <CInput :value="inputValue" v-on="!loading ? inputEvents : null" class="custom-form-control" :disabled="loading" />
              </template>
            </v-date-picker>
          </CCol> -->

          <!-- <CCol sm="1">
            <label class="label-custom">{{ $t('settings.twoWay.results.filters.mcc') }}</label>
            <CInput v-model="mcc" class="custom-form-control" :disabled="loading" />
          </CCol>
          <CCol sm="1">
            <label class="label-custom">{{ $t('settings.twoWay.results.filters.mnc') }}</label>
            <CInput v-model="mnc" class="custom-form-control" :disabled="loading" />
          </CCol> -->
          <!-- <CCol>
            <label class="label-custom">{{ $t('settings.twoWay.results.filters.response-status') }}</label>
            <v-select
              v-model="responseStatusSelected"
              class="no-close border-gray-300 rounded select"
              item-text="label"
              item-value="value"
              :searchable="true"
              :options="responseStatusOptions"
              :disabled="loading"
            />
          </CCol> -->
          <CCol>
            <label class="label-custom">{{ $t('settings.twoWay.results.filters.period') }}</label>
            <form @submit.prevent>
              <v-date-picker
                v-model="timePeriodRange"
                is-required
                is-range
                is24hr
                class="select"
                color="purple"
                mode="dateTime"
                timezone="UTC"
                addInputClasses="newInput"
                :locale="lang"
                :max-date="new Date()"
              >
                <template v-slot="{ inputValue, inputEvents, showPopover, hidePopover }">
                  <CInput
                    :value="rangeFormatted"
                    class="dateInputCustom newInput px-0 text-left inputAppendCustom inputAppendCustom--transparent"
                    add-input-classes="pr-0"
                    v-on="!loading ? inputEvents : null"
                    readonly
                    style="min-width: 260px; background-color: white"
                    @mouseover="showPopover"
                    @mouseleave="hidePopover"
                    :disabled="loading"
                  >
                    <template #append-content>
                      <span @click="clearRange" class="pr-none">
                        <CIcon
                          v-if="inputValue"
                          class="btn-value mt-2 text-center"
                          style="cursor: pointer"
                          name="cilXCircle"
                          size="custom-size"
                          :height="23"
                          viewBox="0 0 32 32"
                        />
                      </span>
                    </template>
                  </CInput>
                </template>
              </v-date-picker>
            </form>
          </CCol>
        </CRow>
        <CRow class="align-items-end">
          <!-- <CCol>
            <label class="label-custom">{{ $t('settings.twoWay.results.filters.period') }}</label>
            <form @submit.prevent>
              <v-date-picker
                v-model="timePeriodRange"
                color="purple"
                mode="range"
                timezone="UTC"
                :locale="lang"
                :max-date="new Date()"
                is-required
                is-range
                addInputClasses="newInput"
                class="select"
              >
                <template v-slot="{ inputValue, inputEvents, showPopover, hidePopover }">
                  <CInput
                    :value="rangeFormatted"
                    class="dateInputCustom newInput px-0 text-left inputAppendCustom inputAppendCustom--transparent"
                    add-input-classes="pr-0"
                    v-on="!loading ? inputEvents : null"
                    readonly
                    style="min-width: 260px; background-color: white"
                    @mouseover="showPopover"
                    @mouseleave="hidePopover"
                    :disabled="loading"
                  >
                    <template #append-content>
                      <span @click="clearRange" class="pr-none">
                        <CIcon
                          v-if="inputValue"
                          class="btn-value mt-2 text-center"
                          style="cursor: pointer"
                          name="cilXCircle"
                          size="custom-size"
                          :height="23"
                          viewBox="0 0 32 32"
                        />
                      </span>
                    </template>
                  </CInput>
                </template>
              </v-date-picker>
            </form>
          </CCol> -->
          <CCol class="text-right">
            <CButton color="primary" variant="outline" class="px-5 py-2 mr-3" :disabled="loading" @click="clearFilters()">
              <span class="font-1xl mr-1">{{ $t('settings.twoWay.results.filters.button.clear') }}</span>
            </CButton>
            <CButton color="primary" class="px-5 py-2" @click="filterData()" :disabled="loading">
              <span class="font-1xl mr-1">{{ $t('settings.twoWay.results.filters.button.filter') }}</span>
              <CIcon name="cilMagnifyingGlass" size="custom-size" :height="26" viewBox="0 0 32 32" />
            </CButton>
          </CCol>
        </CRow>

        <hr />

        <CRow v-if="inboundsResults && inboundsResults.length > 0">
          <CCol class="text-right">
            <CButton class="px-5 py-2 border-dark" size="md" color="white" :disabled="loading" @click="() => (showPopupExport = true)">
              <span class="font-1xl mr-1">{{ $t('settings.twoWay.results.button.export') }}</span>
              <CIcon name="cil-file" class="export-icon" size="custom-size" :height="24" viewBox="0 0 30 30" />
            </CButton>
            <transition name="fade" v-if="showPopupExport">
              <div class="dataTable__popUp popUp" style="left: 85%" @click.stop.stop>
                <div class="popUp__body shadow-sm">
                  <ChooseExport
                    v-show="showPopupExport"
                    :totalRecords="pagination.totalRecords"
                    @confirm="exportData"
                    @cancel="() => (showPopupExport = false)"
                  />
                </div>
              </div>
            </transition>
          </CCol>
        </CRow>

        <div class="mt-4">
          <SenditTable
            :headers="tableHeaders"
            :registers="tableRegisters"
            :itemsPerPage="pagination.itemsPerPage"
            :currentPage="pagination.currentPage"
            :totalPages="pagination.totalPages"
            :loading="loading"
            pagination
            translateHeader
            expandable
            @updatePage="handleUpdatePage"
          >
            <template #inboundSmsReceivedDatetime="{ item }">
              <td>{{ item.inboundSmsReceivedDatetime ? formateDateTime(item.inboundSmsReceivedDatetime) : null }}</td>
            </template>

            <template #isReceived="{ item }">
              <td>
                <span style="width: 150px; display: block" class="ellipsis" :title="item.inboundSmsText">
                  {{ item.inboundSmsText }}
                </span>
              </td>
            </template>

            <template #deliveryReportStatus="{ item }">
              <td class="font-weight-bolder" :class="deliveryReportStatusFormat(item.deliveryReportStatus).color">
                {{ deliveryReportStatusFormat(item.deliveryReportStatus).label }}
                <CIcon
                  v-if="deliveryReportStatusFormat(item.deliveryReportStatus).icon"
                  :name="deliveryReportStatusFormat(item.deliveryReportStatus).icon"
                  size="custom-size"
                  :height="18"
                  viewBox="0 0 32 32"
                />
              </td>
            </template>

            <template #routingStatus="{ item }">
              <td class="font-weight-bolder" :class="deliveredEndpointStatusFormat(item.endpointDeliveryStatus).color">
                {{ deliveredEndpointStatusFormat(item.endpointDeliveryStatus).label }}
                <CIcon
                  v-if="deliveredEndpointStatusFormat(item.endpointDeliveryStatus).icon"
                  :name="deliveredEndpointStatusFormat(item.endpointDeliveryStatus).icon"
                  size="custom-size"
                  :height="18"
                  viewBox="0 0 32 32"
                />
              </td>
            </template>

            <template #expanded-area="{ item }">
              <table class="table table--detail my-4">
                <tbody>
                  <tr>
                    <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300 font-weight-bold" style="width: 300px">
                      {{ $t('settings.twoWay.results.table.content.details.message-content') }}
                    </td>
                    <td class="px-4 border border-gray-300">
                      {{ item.inboundSmsText }}
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300 font-weight-bold" style="width: 300px">
                      {{ $t('settings.twoWay.results.table.content.details.received-segments-count') }}
                    </td>
                    <td class="px-4 border border-gray-300">
                      {{ item.inboundSmsTotalSegments }}
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300 font-weight-bold" style="width: 300px">
                      {{ $t('settings.twoWay.results.table.content.details.mcc-mnc') }}
                    </td>
                    <td class="px-4 border border-gray-300">
                      {{ `${item.inboundSmsMCC}/${item.inboundSmsMNC}` }}
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300 font-weight-bold" style="width: 300px">
                      {{ $t('settings.twoWay.results.table.content.reply-text') }}
                    </td>
                    <td class="px-4 border border-gray-300">
                      {{ item.responseText }}
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300 font-weight-bold" style="width: 300px">
                      {{ $t('settings.twoWay.results.table.content.number-segments-reply') }}
                    </td>
                    <td class="px-4 border border-gray-300">
                      {{ item.responseTotalSegments }}
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300 font-weight-bold" style="width: 300px">
                      {{ $t('settings.twoWay.results.table.content.reponse-date') }}
                    </td>
                    <td class="px-4 border border-gray-300">
                      {{ item.responseSentDateTime ? formatDateTimeLong(item.responseSentDateTime) : '' }}
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300 font-weight-bold" style="width: 300px">
                      {{ $t('settings.twoWay.results.table.content.reponse-status') }}
                    </td>
                    <td class="px-4 border border-gray-300">
                      <span class="font-weight-bold" :class="deliveryReportStatusFormat(item.deliveryReportStatus).color">
                        {{ deliveryReportStatusFormat(item.deliveryReportStatus).label }}
                      </span>
                      <p v-if="item.deliveryReportDescription" class="py-2">
                        {{ item.deliveryReportDescription }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-gray-200 text-capitalize text-black-50 px-4 border border-gray-300 font-weight-bold" style="width: 300px">
                      {{ $t('settings.twoWay.results.table.content.endpoint') }}
                    </td>
                    <td class="px-4 border border-gray-300">
                      <span class="font-weight-bold" :class="deliveredEndpointStatusFormat(item.endpointDeliveryStatus).color">
                        {{ deliveredEndpointStatusFormat(item.endpointDeliveryStatus).label }}
                      </span>
                      <p v-if="item.endpoint" class="py-2">
                        {{ item.endpoint }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </SenditTable>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import services from '@/services'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import { dateFormatString, getUserDateFormat, dateTimeFormatString, dateFormatStringFull, dateTimeShortFormatString } from '@/utils/dateUtil.js'
import ChooseExport from '@/components/ChooseExport'
import SenditTable from '@/components/table/SenditTable.vue'
import fileDownload from 'js-file-download'
import { getFilenameFromContentDisposition } from '@/utils/responseHeaderUtils'
import { PLAN_TYPES } from '@/views/plansSubscriptions/constants'

const statusEnum = {
  DELIVERED: 1,
  PENDING: 2,
  NOT_DELIVERED: 3,
}

// const registersMock = [
//   {
//     inboundSmsMsisdn: '123456',
//     accessNumber: '654321',
//     inboundSmsReceivedDatetime: new Date().toISOString(),
//     isPending: false,
//     deliveryReportStatus: 1,
//     routingStatus: true,
//     inboundSmsText: 'teste mock teste mock teste mock teste mock teste mock teste mock teste',
//     inboundSmsTotalSegments: 5,
//     inboundSmsMCC: 123,
//     inboundSmsMNC: 321,
//     responseText: 'teste mock teste mock teste mock teste mock teste mock teste mock teste',
//     responseEncoding: 7,
//     responseSentDateTime: new Date().toISOString(),
//     deliveryReportDescription: 'teste mock teste mock teste mock teste mock teste mock teste mock teste',
//     endpoint: 'https://teste.com',
//   },
// ]

export default {
  name: 'TwoWayResults',
  components: {
    vSelect,
    SenditTable,
    ChooseExport,
  },
  data() {
    return {
      loadingFilter: false,
      loadingConsulta: false,
      showPopupExport: false,
      destinationNumberOptions: [],
      destinationNumberSelected: { label: this.$t('settings.twoWay.results.table.content.status.all'), value: null },
      originNumber: null,
      dateOfReceipt: null,
      mcc: null,
      mnc: null,
      timePeriodRange: null,
      responseStatusSelected: { label: this.$t('settings.twoWay.results.table.content.status.all'), value: null },
      responseStatusOptions: [
        { label: this.$t('settings.twoWay.results.table.content.status.all'), value: null },
        { label: this.$t('settings.twoWay.results.table.content.status.delivered'), value: statusEnum.DELIVERED },
        { label: this.$t('settings.twoWay.results.table.content.status.not-delivered'), value: statusEnum.NOT_DELIVERED },
        { label: this.$t('settings.twoWay.results.table.content.status.pending'), value: statusEnum.PENDING },
      ],
      inboundsResults: [],
      loadingData: false,
      pagination: {
        itemsPerPage: 10,
        currentPage: 0,
        totalPages: 0,
      },
      hasNoTwoWay: false,
    }
  },
  computed: {
    timePeriodRangeFormatted() {
      if (!this.timePeriodRange) return null

      const userDateTimeFormat = getUserDateFormat(this.$store.state.auth.user.dateTimeFormat)

      const formattedStart = dateFormatString(this.timePeriodRange.start.toISOString(), '', userDateTimeFormat)
      const formattedEnd = dateFormatString(this.timePeriodRange.end.toISOString(), '', userDateTimeFormat)

      return {
        start: formattedStart,
        end: formattedEnd,
      }
    },
    hasRange() {
      return Boolean(this.timePeriodRange && this.timePeriodRange.start && this.timePeriodRange.end)
    },
    rangeFormatted() {
      if (!this.hasRange) return null

      // const userDateTimeFormat = getUserDateFormat(this.$store.state.auth.user.dateTimeFormat)

      // const formattedStart = DateTime.fromJSDate(this.timePeriodRange.start).setZone('UTC').toFormat(userDateTimeFormat)

      const formattedStart = dateTimeShortFormatString(this.timePeriodRange.start.toISOString(), 'UTC').replace(',', '')

      // const formattedEnd = DateTime.fromJSDate(this.timePeriodRange.end).setZone('UTC').toFormat(userDateTimeFormat)
      const formattedEnd = dateTimeShortFormatString(this.timePeriodRange.end.toISOString(), 'UTC').replace(',', '')

      return `${formattedStart} - ${formattedEnd}`
    },
    tableHeaders() {
      return [
        { key: 'inboundSmsMsisdn', label: this.$t('settings.twoWay.results.table.headers.origin-number'), sorter: false },
        { key: 'accessNumber', label: this.$t('settings.twoWay.results.table.headers.destination-number'), sorter: false },
        { key: 'inboundSmsReceivedDatetime', label: this.$t('settings.twoWay.results.table.headers.data-time-reception'), sorter: false },
        { key: 'isReceived', label: this.$t('settings.twoWay.results.table.headers.message-received'), sorter: false },
        { key: 'deliveryReportStatus', label: this.$t('settings.twoWay.results.table.headers.response-status'), sorter: false },
        { key: 'routingStatus', label: this.$t('settings.twoWay.results.table.headers.routing-status'), sorter: false },
      ]
    },
    tableRegisters() {
      // return registersMock
      return this.inboundsResults
    },
    ...mapGetters({
      lang: 'getLang',
    }),
    loading() {
      return this.loadingFilter || this.loadingConsulta
    },
  },
  mounted() {
    if (this.$store.state.auth.session.organization.planType != PLAN_TYPES.CORPORATE) {
      this.hasNoTwoWay = true
    } else {
      this.getTwoWayConfig()
    }

    this.getAccessNumbers()

    if (this.$route.query.accessNumber) this.getData(this.$route.query.accessNumber)
    else this.getData()
  },
  methods: {
    originNumberInputCheck(e) {
      const regex = /^[0-9]*$/
      const input = e.target
      if (!regex.test(input.value)) {
        e.preventDefault()
        input.value = this.originNumber = input.value.replace(/[^0-9]/g, '')
      } else return true
    },
    exportData(exportConfig) {
      const organizationId = this.$route.params.organizationId

      const filters = {
        accessNumber: this.destinationNumberSelected.value,
        inboundSmsMsisdn: this.originNumber,
        receivedDateTime: this.dateOfReceipt,
        responseMcc: this.mcc,
        responseMnc: this.mnc,
        deliveryReportStatus: this.responseStatusSelected.value,
        beginDateTime: this.timePeriodRange?.start,
        endDateTime: this.timePeriodRange?.end,
        format: exportConfig.format,
      }

      if (exportConfig.delimiter) {
        filters.delimiter = exportConfig.delimiter
      }
      this.loadingConsulta = true
      this.showPopupExport = false

      services
        .getInboundExport(organizationId, filters)
        .then((res) => {
          const fileName = getFilenameFromContentDisposition(res.headers['content-disposition'])
          fileDownload(res.data, fileName, res.headers['content-type'])
        })
        .finally(() => (this.loadingConsulta = false))
    },

    filterData() {
      this.pagination.currentPage = 0
      this.getData()
    },

    getData(accessNumber = null) {
      const organizationId = this.$route.params.organizationId

      const filters = {
        accessNumber: this.destinationNumberSelected.value,
        inboundSmsMsisdn: this.originNumber,
        receivedDateTime: this.dateOfReceipt,
        responseMcc: this.mcc,
        responseMnc: this.mnc,
        deliveryReportStatus: this.responseStatusSelected.value,
        beginDateTime: this.timePeriodRange?.start,
        endDateTime: this.timePeriodRange?.end,
        page: this.pagination.currentPage,
        count: this.pagination.itemsPerPage,
      }

      if (accessNumber) filters.accessNumber = accessNumber

      this.loadingConsulta = true

      services
        .getInboundResult(organizationId, filters)
        .then((res) => {
          this.inboundsResults = res.data.data.results
          this.pagination.currentPage = res.data.data.pagination.currentPage
          this.pagination.totalRecords = res.data.data.pagination.totalRecords
          this.pagination.totalPages = res.data.data.pagination.totalPages
        })
        .finally(() => (this.loadingConsulta = false))
    },
    getAccessNumbers() {
      const organizationId = this.$route.params.organizationId
      this.loadingFilter = true
      services
        .getTwoWayAccessNumbers(organizationId, { page: 0, count: 1000 })
        .then((res) => {
          this.destinationNumberOptions = [{ label: this.$t('settings.twoWay.results.table.content.status.all'), value: null }]

          this.destinationNumberOptions.push(
            ...res.data.data.organizationAccessNumbers.map((el) => {
              return {
                label: el.number,
                value: el.number,
              }
            }),
          )

          if (this.$route.query.accessNumber) {
            this.destinationNumberSelected = this.destinationNumberOptions.find((el) => el.value == this.$route.query.accessNumber)
          }
        })
        .finally(() => (this.loadingFilter = false))
    },

    clearFilters() {
      this.destinationNumberSelected = { label: this.$t('settings.twoWay.results.table.content.status.all'), value: null }
      this.responseStatusSelected = { label: this.$t('settings.twoWay.results.table.content.status.all'), value: null }
      this.originNumber = null
      this.dateOfReceipt = null
      this.mcc = null
      this.mnc = null
      this.timePeriodRange = null
    },
    clearRange() {
      this.timePeriodRange = null
    },
    handleUpdatePage(page) {
      this.pagination.currentPage = page
      this.getData()
    },
    formateDateTime(date) {
      return dateTimeFormatString(date)
    },
    formatDateTimeLong(date) {
      return dateFormatStringFull(date)
    },
    deliveryReportStatusFormat(status) {
      switch (status) {
        case statusEnum.DELIVERED:
          return {
            label: this.$t('settings.twoWay.results.table.content.status.delivered'),
            color: 'text-success',
          }
        case statusEnum.NOT_DELIVERED:
          return {
            label: this.$t('settings.twoWay.results.table.content.status.not-delivered'),
            color: 'text-error',
            icon: 'infoSolid',
          }
        case statusEnum.PENDING:
          return {
            label: this.$t('settings.twoWay.results.table.content.status.pending'),
            color: 'text-warning',
          }
        default:
          return {
            label: this.$t('settings.twoWay.results.table.content.status.notConfigured'),
            color: 'text-gray-400',
          }
      }
    },
    deliveredEndpointStatusFormat(status) {
      switch (status) {
        case 'DELIVERED':
          return {
            label: this.$t('settings.twoWay.results.table.content.status.delivered'),
            color: 'text-success',
          }
        case 'NOT_DELIVERED':
          return {
            label: this.$t('settings.twoWay.results.table.content.status.not-delivered'),
            color: 'text-error',
            icon: 'infoSolid',
          }
        case 'PENDING':
          return {
            label: this.$t('settings.twoWay.results.table.content.status.pending'),
            color: 'text-warning',
          }
        default:
          return {
            label: this.$t('settings.twoWay.results.table.content.status.notConfigured'),
            color: 'text-gray-400',
          }
      }
    },
    redirectToConfiguration() {
      this.$router.push({ name: 'twoway-configuration' })
    },
    getTwoWayConfig() {
      const organizationId = this.$route.params.organizationId

      services
        .getTwoWayConfig(organizationId)
        .then((res) => {
          this.hasNoTwoWay = res.data.data.value === 1
        })
        .catch((error) => {
          const errorCode = error.response.data.errorCode

          // INBOUND_SMS_CONFIG_UNAUTHORIZED
          if (errorCode === 2800001) {
            this.hasNoTwoWay = true
          }
        })
    },
  },
}
</script>
<style>
.dateInputCustom .form-control[readonly] {
  background-color: white !important;
}

.custom-form-control input {
  height: 56px !important;
}

.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
